export const environment = {
    local: false,
    development: false,
    testing: false,
    production: true,
    updateInterval: (10 * 1000),
    feedbackPostURL: "https://phpapps.usask.ca/site-feedback/feedback_post.php",
    hasServiceWorker: true,
    csvFolderLocation: "/financial-planning-estimator/data/",
    enableGA: true,
    gaTrackingId: "GTM-NPKLVP6",
    gaAuth: "",
    logLevel: "ERROR"
};
